<template>
	<SearchableDropdown
		v-model="selectedAccount"
		:options="dropdownOptions"
		:label="noLabel ? '' : 'Account'"
		placeholder="-- All Accounts --"
		:is-searchable="true"
		:multi-select="false"
		:show-default-option="true"
		@change="handleChange"
	/>
</template>

<script>
import SearchableDropdown from './SearchableDropdown.vue'

export default {
	components: {
		SearchableDropdown
	},
	props: {
		modelValue: [String, Number],
		accounts: {
			type: Array,
			required: true
		},
		allowTenants: {
			type: Boolean,
			default: false
		},
		tenantLabel: {
			type: String,
			default: 'All Tenants'
		},
		noLabel: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue'],
	computed: {
		selectedAccount: {
			get() {
				return this.modelValue || null
			},
			set(value) {
				this.$emit('update:modelValue', value || null)
			}
		},
		filteredAccounts() {
			const selectedTenant = this.$global.getSelectedTenant()
			if (!selectedTenant) return this.accounts

			return this.accounts
				.filter((account) => account.tenant?.id === parseInt(selectedTenant))
				.sort((a, b) => a.name.localeCompare(b.name))
		},
		dropdownOptions() {
			const options = []

			if (this.allowTenants) {
				options.push({
					value: -1,
					label: this.tenantLabel
				})
			}

			options.push(
				...this.filteredAccounts.map((account) => ({
					value: account.id,
					label: account.name
				}))
			)

			return options
		}
	},
	methods: {
		handleChange(value) {
			this.selectedAccount = value
		}
	}
}
</script>
